module.exports = __webpack_public_path__ + "static/flux-wireframe-4-19b1971fbc3ab66f2222601db493ee5e.png";